import sessionStore from 'client/Session/SessionStore';
import {history} from 'client/history';
import {getDoesStudentHaveActiveClassroomQuery} from 'lib/UserAccessUtil';

export async function redirect({location} = {}) {
  let target = null;

  if (location) {
    target = getLocationRedirectTarget(location.query);
  }

  if (target) {
    history.pushState(null, target);
  } else if (sessionStore.hasValidSession()) {
    /**
     * If the user is logged in, we redirect them to their user type's
     * default page.
     */
    history.pushState(null, await getUserTypeRedirectTarget());
  } else {
    /**
     * The default case is to take a user home.
     *
     * This is tripped if a user is
     * 1. logged out
     * 2. no `location` is provided
     */
    global.document.location = '/';
  }
}

function getLocationRedirectTarget(query) {
  if (query && query.classroomId && query.classroomInvitationId) {
    return `/classes?classroomId=${query.classroomId}&classroomInvitationId=${query.classroomInvitationId}`;
  }

  return null;
}

export async function getUserTypeRedirectTarget() {
  if (sessionStore.isSuper()) {
    return '/dennis';
  }

  if (sessionStore.isContentManager()) {
    return '/dennis/content';
  }

  if (sessionStore.isAuthor()) {
    return '/dennis/content/dashboard';
  }
  /**
   * Teachers always go to `/classes`
   */
  if (sessionStore.isTeacher()) {
    return '/classes';
  }
  /**
   * For any other user type (students), we redirect them to `/classes`
   * if they are in a licensed class.
   */
  if (sessionStore.hasValidSession()) {
    const activeClassrooms = await getDoesStudentHaveActiveClassroomQuery(
      sessionStore.getUserId()
    ).getResourcePromise();
    if (!activeClassrooms.isEmpty()) {
      return '/classes';
    }
  }

  return '/dashboard';
}

export function shouldRedirectFromPathname(pathname, {includeHome = false} = {}) {
  const redirectPaths = ['/forgot-password', '/reset-password', '/signup', '/social'];
  if (includeHome) {
    redirectPaths.push('/home');
  }
  return (
    (includeHome && pathname === '/') ||
    redirectPaths.some((path) => path === pathname) ||
    (pathname.startsWith('/dennis') && !sessionStore.hasAuthorAccess()) || // non dennis user trying to access dennis routes. This is needed to redirect non dennis users away from dennis
    (pathname.startsWith('/dennis') &&
      !pathname.startsWith('/dennis/content') &&
      !sessionStore.isSuper()) // non super users only have access to content routes in Dennis (authors, content managers). This is needed to redirect authors and content managers back to the content
  );
}
